/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconPhysotherapist = createReactComponent("physotherapist", "IconPhysotherapist", [
  ["path", { d: "M9 15l-1 -3l4 -2l4 1h3.5", key: "svg-0" }],
  ["path", { d: "M4 19m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0", key: "svg-1" }],
  ["path", { d: "M12 6m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0", key: "svg-2" }],
  ["path", { d: "M12 17v-7", key: "svg-3" }],
  ["path", { d: "M8 20h7l1 -4l4 -2", key: "svg-4" }],
  ["path", { d: "M18 20h3", key: "svg-5" }]
]);

export { IconPhysotherapist as default };
//# sourceMappingURL=IconPhysotherapist.js.map
